module.exports = __webpack_public_path__ + "img/Img_box_duotone_line.d6dcad64.svg";